/** The header actions of one pane (a peek or the split pane), over the navigator's actions. */
import type { NavApi, PaneControls } from './nav-context.js';
import { closePane, type PaneName, stepPane } from './nav-state.js';
import { currentEntry } from './pane-history.js';

export function paneControls(api: NavApi, which: PaneName): PaneControls {
  const current = () => {
    const stack = api.state[which];
    return stack ? currentEntry(stack) : null;
  };
  return {
    onClose: () => api.update((s) => closePane(s, which)),
    onBack: () => api.update((s) => stepPane(s, which, 'back')),
    onForward: () => api.update((s) => stepPane(s, which, 'forward')),
    // Pane 2's "Open as page" navigates pane 1, so it opens as from the page, not into pane 2.
    onOpenAsPage: () => {
      const target = current();
      if (target) api.open({ target, mode: 'full', source: 'main' });
    },
    onOpenInSplit: () => {
      const target = current();
      if (target) api.open({ target, mode: 'split', source: which });
    },
  };
}
